import { Popper } from '@mui/material';

import type { PopperProps } from '@mui/material/Popper/Popper';

const PopperBottom = (props: PopperProps) => {
  return (
    <Popper
      {...props}
      placement={'bottom'}
      modifiers={[
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['bottom'],
          },
        },
      ]}
    />
  );
};

export default PopperBottom;
